import type { CreateTeamPayload, GetTeamsParams, Team } from '@shared/types/entities';

import { api } from './client';
import { type PaginatedResponse, buildQuery } from './types';

export type { CreateTeamPayload, GetTeamsParams, Team };

export async function getTeamsApi(params?: GetTeamsParams): Promise<PaginatedResponse<Team>> {
  return api.get(`/teams${buildQuery(params as Record<string, unknown>)}`);
}

export async function getTeamApi(id: number): Promise<Team> {
  return api.get(`/teams/${id}`);
}

export async function createTeamApi(payload: CreateTeamPayload): Promise<Team> {
  return api.post('/teams', payload);
}
